import { Column, Row } from 'app/design/primitives/box';
import { Switch } from 'app/design/primitives/switch';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import type { NeedToggle } from './notification-toggle.types';

const theme = createDSTheme();
const NEED_SOURCE_ICON_SIZE = 30;
const NEED_SOURCE_ROW_HEIGHT = 58;

export const NeedToggleCard = ({
  toggle,
  usesSectorNeedSources,
}: {
  toggle: NeedToggle;
  usesSectorNeedSources: boolean;
}) => {
  const showSources = toggle.value && toggle.groups.length > 1 && !isWhiteLabel(WhiteLabel.Refrain);
  return (
    <Column
      gap="spacing.general.x4"
      padding="spacing.general.x4"
      backgroundColor="surface.primary-neutral"
      borderRadius="radius.sm"
    >
      <Row
        alignItems="center"
        borderBottomWidth={showSources ? 1 : 0}
        paddingBottom={showSources ? 'spacing.general.x4' : undefined}
        style={{ borderBottomColor: theme.colors['surface.disabled'] }}
      >
        <Text flex={1} fontWeight="700" variant="bodySmall">
          {toggle.label}
        </Text>
        <Switch
          alignSelf="center"
          accessibilityLabel={toggle.label}
          onValueChange={toggle.onValueChange}
          value={toggle.value}
        />
      </Row>

      {showSources ? (
        <Column borderRadius="radius.sm" overflow="hidden">
          {toggle.groups.map((group, index) => (
            <Row
              alignItems="center"
              backgroundColor="surface.default"
              borderTopWidth={index === 0 ? 0 : 1}
              gap="spacing.general.x4"
              height={NEED_SOURCE_ROW_HEIGHT}
              key={`${group.type}:${group.id}`}
              paddingHorizontal="spacing.general.x4"
              style={{ borderTopColor: theme.colors['surface.disabled'] }}
            >
              {usesSectorNeedSources ? (
                <Row
                  alignItems="center"
                  backgroundColor="surface.brand.bold"
                  borderRadius="radius.sm"
                  height={NEED_SOURCE_ICON_SIZE}
                  justifyContent="center"
                  overflow="hidden"
                  width={NEED_SOURCE_ICON_SIZE}
                >
                  {group.image}
                </Row>
              ) : (
                group.image
              )}
              <Text flex={1} fontWeight="700" variant="bodySmall">
                {group.label}
              </Text>
              <Switch
                alignSelf="center"
                accessibilityLabel={group.label}
                onValueChange={group.onValueChange}
                value={group.value}
              />
            </Row>
          ))}
        </Column>
      ) : null}
    </Column>
  );
};
